<template>
    <tr>
        <td>
            <a :href="this.axios.defaults.baseImageURL + 'v1c_files/' + product.image" data-fancybox>
                <img class="icon" :src="this.axios.defaults.baseImageURL + 'v1c_files/' +  product.image" alt="">
            </a>
        </td>
        <td class="code">{{ product.vendor_code }}</td>
        <td class="name">
            <a :title="product.name" :href="'/product/'+product.alias" target="_blank">
                <span>{{ product.name }}</span>
            </a>
            <span class="copyText tooltip" title="скопировать полное наименование" @click.stop.prevent="copyText">
                <i class="fa fa-files-o" aria-hidden="true"></i>
            </span>
        </td>

        <td class="remain text-center">
            <span>{{ product.remain > 50 ? 'больше 50' : product.remain }} (шт)</span>
            <button @click="checkSubscribe" :class="subscribe ? 'active' : ''" class="alarm"
                    v-if="product.remain < 50 && waitingIcon">
                <i class="fa fa-bell-o" aria-hidden="true"></i>
            </button>
        </td>

        <td class="price text-center">{{ product.price | chunk(product.price) }}</td>

        <td class="quantity">
            <div class="count">
                <button v-if="product.quantity > 0" @click="minus" class="minus">
                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                </button>
                <input
                    type="number"
                    class="count_value"
                    v-model="product.quantity"
                    name="count"
                    min="0"
                    @change="changeQuantity"
                >
                <button @click="plus" class="plus"><i class="fa fa-plus-circle" aria-hidden="true"></i></button>
            </div>
            <div class="remain"></div>
        </td>

        <td class="totalPrice text-center">{{ product.quantity * product.price | chunk(product.quantity * product.price) }} тг</td>


        <td v-if="itemDelete"><button class="btn btn-outline-danger" @click="removeProduct(product)"><i class="fa fa-trash-o" aria-hidden="true"></i></button></td>
    </tr>
</template>

<script>

    import Vue from 'vue';

    var $ = require("jquery");
    window.jQuery = $;
    var fancyBox = require("@fancyapps/fancybox");

    import VueClipboard from 'vue-clipboard2';

    import {mapActions, mapGetters} from 'vuex';


    Vue.use(VueClipboard);

    export default {
        props: ['product', 'waitingIcon', 'itemDelete'],

        data() {
            return {
                subscribe: false,
                searchChange: false
            }
        },

        mounted() {
            if (this.product.subscribe_product_id) {
                this.subscribe = true;
            }

            if (!this.product.quantity){
                this.product.quantity = 0
            }


            $('[data-fancybox]').fancybox({
                touch: false,
                buttons: [
                    "zoom",
                    "close",
                ],

                image: {
                    preload: true
                },

            });
        },

        methods: {

            ...mapActions({
                checkProductAction: 'checkProduct',
                checkSubscribeAction: 'checkSubscribe',
                removeProduct: 'removeProduct'
            }),

            minus: function () {
                if (this.product.quantity > 0) {
                    this.product.quantity--;
                    this.checkProduct();
                }
            },

            plus: function () {
                this.product.quantity++;
                this.checkProduct()
            },

            changeQuantity: function () {
                console.log(this.product.quantity)
                this.checkProduct()
            },

            checkProduct: function () {
                this.checkProductAction({
                    'id': this.product.id,
                    'v1c_id': this.product.v1c_id,
                    'alias': this.product.alias,
                    'quantity': this.product.quantity,
                    'price': this.product.price,
                    'remain': this.product.remain,
                    'vendor_code': this.product.vendor_code,
                    'name': this.product.name,
                    'image': this.product.image,
                })
            },

            checkSubscribe() {
                this.product.subscribe = this.subscribe
                this.checkSubscribeAction(this.product);
                this.subscribe = !this.subscribe;
            },

            copyText: function () {
                this.$copyText(this.product.name).then(function (e) {
                    console.log(e)
                }, function (e) {
                    console.log(e)
                })
            },
        },
        filters: {
            chunk: function (x) {
                var parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            },
        }
    }
</script>

<style lang="scss">
    @import "~@fancyapps/fancybox/dist/jquery.fancybox.min.css";

    .quantity {
        .count {
            position: relative;
            width: 125px;
            margin: 0 auto;

            display: flex;
            justify-content: center;
            align-items: center;

            .count_value {
                width: 50px;
                padding: 5px;
                margin: 0 10px;
                text-align: center;
                border: 0;
                background-color: transparent;
            }

            button {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);

                background-color: transparent;
                border: 0;
                cursor: pointer;

                i {
                    font-size: 22px;
                }

                &.minus {
                    left: 0;
                }

                &.plus {
                    right: 0;

                    i {
                        &::before {
                            color: green;
                        }
                    }
                }
            }
        }
    }

    .totalPrice {
        min-width: 125px;
    }


    .border-bottom {
        border-bottom: 1px solid red;
    }

    .name {
        width: 30%;
    }

    .jBox-Tooltip {
        .jBox-container {
            .jBox-content {
                max-width: 300px;
                padding: 5px 10px;
                font-size: 12px;
                text-align: center;
            }
        }
    }

    .alarm {
        background-color: transparent;
        border: 0;
        cursor: pointer;

        &.active {
            color: red;
        }

        i {
            &:before {
                font-size: 18px;
            }
        }
    }

    .quantity .count{
        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */
        input[type=number] {
            -moz-appearance: textfield;
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/app/pages/order/Product.vue